import * as React from 'react';

import type {SalesDocumentUpdateInput} from 'nutshell-graphql-types';

import {SaveableWrapper} from '../../saveable-wrapper/saveable-wrapper';

import {QuoteTextArea} from '../editable/quote-text-area';
import {FOOTER} from '../helpers';
import {QuoteNoteSection} from '../read-only/quote-note-section';

import styles from '../quote.module.css';

type Props = {
    onSave: (arg1: SalesDocumentUpdateInput) => void;
    onCancel: () => void;
    isActive: boolean;
    id: string;
    footer: string;
    onToggleActive: (arg1: string) => void;
    forceSave: boolean;
    isTemplate: boolean;
    isImmutable: boolean;
};

export function QuoteFooterWrapper(props: Props) {
    const {id, onSave} = props;
    const [footer, setFooter] = React.useState<string>(props.footer);

    React.useEffect(() => {
        setFooter(props.footer);
    }, [props.footer]);

    const handleSave = React.useCallback(() => {
        onSave({
            salesDocument: id,
            footer,
        });
    }, [id, onSave, footer]);

    React.useEffect(() => {
        if (props.forceSave) {
            handleSave();
        }
    }, [props.forceSave, handleSave]);

    const handleCancel = () => {
        setFooter(props.footer);
        props.onCancel();
    };

    return (
        <SaveableWrapper
            isActive={props.isActive}
            onSave={handleSave}
            onCancel={handleCancel}
            onToggleActive={props.onToggleActive}
            sectionName={FOOTER}
            noPadding={true}
            isImmutable={props.isImmutable}
            showEditIcon={props.isTemplate}
        >
            {props.isActive ? (
                <div className={styles['editable-footer-wrapper']}>
                    <QuoteTextArea
                        value={footer}
                        onChange={setFooter}
                        bottomPaddingForToolbar={true}
                        largerText={true}
                        textAlignCenter={true}
                        isFullHeight={false}
                    />
                </div>
            ) : (
                <div className={styles['read-only-footer-wrapper']}>
                    <QuoteNoteSection text={footer} />
                </div>
            )}
        </SaveableWrapper>
    );
}
